/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { Search, TOOLBAR_ITEM_TYPE, TOOLBAR_VIEW_TYPE } from '@veeam-vspc/components';

import { useLang } from 'views/providers/LangProvider/hooks';
import { ToolbarWithExport } from 'views/components/ToolbarWithExport';
import { StatusToggleFilter } from 'views/components/filters/StatusToggleFilter';
import { JobSessionTaskStatusRepresentation } from '../../../../../../../../enums';

import type { ToolbarWithExportProps } from 'views/components/ToolbarWithExport';

export interface FileServersDialogToolbarProps extends Omit<ToolbarWithExportProps, 'method' | 'items'> {
    method?: string;
}

export const FileServersDialogToolbar: React.FC<FileServersDialogToolbarProps> = (props) => {
    const { method = 'GetFileJobSources', ...restProps } = props;
    const lang = useLang();
    const statuses = [
        { title: lang.SUCCESS, value: JobSessionTaskStatusRepresentation.Success },
        { title: lang.WARNING, value: JobSessionTaskStatusRepresentation.Warning },
        { title: lang.FAILED, value: JobSessionTaskStatusRepresentation.Failed },
        { title: lang.RUNNING, value: JobSessionTaskStatusRepresentation.InProgress },
        {
            title: lang.INFORMATION,
            value: [
                JobSessionTaskStatusRepresentation.Unknown,
                JobSessionTaskStatusRepresentation.Pending,
            ],
        },
    ];

    return (
        <ToolbarWithExport
            {...restProps}
            method={method}
            view={TOOLBAR_VIEW_TYPE.spotted}
            items={[
                {
                    type: TOOLBAR_ITEM_TYPE.customControl,
                    render: () => (
                        <Search
                            name='name'
                            placeholder={lang.SERVER}
                            hasSearchButton={true}
                            maxLength={512}
                        />
                    ),
                },
                {
                    type: TOOLBAR_ITEM_TYPE.customControl,
                    render: () => (
                        <StatusToggleFilter
                            statuses={statuses}
                        />
                    ),
                },
            ]}
        />
    );
};
